<template>
  <div class="itserve-input" :class="'size-' + variant">
    <div class="input-wrapper">
      <label
        class="itserve-label"
        :for="'_itserve-input-' + name"
        :class="
          formErrors !== null &&
          Object.keys(formErrors.errors).indexOf(name) >= 0
            ? `error-label label-show-up show-label`
            : `standard-label ` +
              (content.length ? 'label-show-up show-label' : '')
        "
        >{{
          formErrors !== null &&
          Object.keys(formErrors.errors).indexOf(name) >= 0
            ? formErrors.errors[name][0]
            : placeholder
        }}</label
      >
      <div class="field-container">
        <input
          :id="'_itserve-input-' + name"
          :type="currentType"
          :inputmode="inputmode"
          v-model="content"
          @input="changeModelValue(name)"
          :disabled="disabled"
          :pattern="type === 'number' ? '\d*' : ''"
          :name="name"
          :placeholder="placeholder"
          class="itserve-input-field"
          :class="[
            formErrors !== null &&
            Object.keys(formErrors.errors).indexOf(name) >= 0
              ? 'error-field'
              : '',
            theme === 'dark' ? 'dark-theme' : '',
          ]"
        />
        <span
          v-if="type === 'password'"
          class="eye-icon"
          @click="togglePasswordVisibility"
        >
          <eye-off-icon v-if="currentType === 'password'" :size="20" />
          <eye-icon v-else :size="20" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import appBridge from "@/mixins/app-bridge";
import EyeIcon from "vue-material-design-icons/Eye";
import EyeOffIcon from "vue-material-design-icons/EyeOff";

export default {
  mixins: [appBridge],
  components: {
    EyeIcon,
    EyeOffIcon,
  },
  props: {
    theme: {
      type: String,
      default: "light",
    },
    value: [Number, String],
    variant: {
      type: String,
      default: "default",
    },
    name: String,
    type: String,
    inputmode: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formErrors() {
      return this.$store.state.Api.errors;
    },
  },
  data() {
    return {
      content: this.value ? this.value : "",
      currentType: this.type,
    };
  },
  methods: {
    changeModelValue(name) {
      this.$emit("input", this.content);
      this.deleteFieldError(name);
    },
    deleteFieldError(name) {
      if (
        this.formErrors !== null &&
        Object.keys(this.formErrors.errors).indexOf(name) >= 0
      ) {
        this.$store.commit("Api/deleteErrorByFieldName", name);
      }
    },
    togglePasswordVisibility() {
      this.currentType = this.currentType === "password" ? "text" : "password";
    },
  },
};
</script>
<style scoped>
@import "../../../node_modules/vant/lib/cell-group/index.css";
@import "../../../node_modules/vant/lib/cell/index.css";
@import "../../../node_modules/vant/lib/field/index.css";
.itserve-label {
  text-align: left;
}
.itserve-input {
  margin: 0 0 15px 0;
}
.itserve-input:focus::placeholder {
  color: transparent;
}
.input-wrapper {
  text-align: center;
  position: relative;
  padding-top: 10px;
}
.field-container {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 337px;
}
.eye-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #7f8c8d;
}
.itserve-input-field:focus {
  border-color: #2e73b4 !important;
  background-color: #ffffff;
}

.itserve-input-field::placeholder {
  font-size: 18px;
}
.itserve-input-field {
  width: 100%;
  outline: 0;
  outline: none;
  font-size: 16px;
  padding: 10px 10px 10px 10px;
  max-width: 337px;
  box-sizing: border-box;
  background-color: #fff;
  text-align: center;
}

/* ✅ Финальные стили для темной темы */
.itserve-input-field.dark-theme {
  background-color: transparent !important;
  color: #ffffff !important;
  border: 1px solid #34495e !important;
  border-radius: 8px !important;
  padding: 12px !important;
}
.itserve-input-field.dark-theme::placeholder {
  color: #ffffff !important;
}
.itserve-input-field.dark-theme:focus {
  border-color: #34495e !important;
  background-color: transparent !important;
}
</style>
<style>
.size-small {
  margin-top: 0 !important;
}
.size-small label {
  margin-left: 0;
}
.size-small input {
  width: 100% !important;
  padding: 2px 2px 2px 0 !important;
}
.size-small input::placeholder {
  text-align: center;
  font-size: 7px !important;
}
</style>
